"use strict";

var moment = require("moment");

// will return current date format based on locale
function getDateFormat(locale= null){
    var today = moment();
    var userLang = locale ? locale : (navigator.language || navigator.userLanguage);
    var date = today.date();
    var month = today.month()+1;
    var year = today.year();

    userLang = userLang.search("en-")>-1?'en':userLang;
    var tempMoment = moment;
    tempMoment.locale(userLang);
    var currentFormat = tempMoment().format("L");
    date = ((date>0 && date<10)?"0":"")+date
    month = ((month>0 && month<10)?"0":"")+month
    var formats=[
        {'format':'dd/mm/yyyy','value':date+"/"+month+"/"+year},
        {'format':'mm/dd/yyyy','value':month+"/"+date+"/"+year},
        {'format':'yyyy/mm/dd','value':year+"/"+month+"/"+date}
    ];
    for(var each in formats)
    {
        if(currentFormat == formats[each].value)
        {
            return formats[each].format;
            break;
        }
    }
}

const currentFormat = getDateFormat();

// speical character and normal format conversions
var normalFormat = [
    {
        //=
        'format':[/^[=]{1}$/i],
        'equ':function(value){
            return Date.today();
        }
    },
    {
        //>
        'format':[/^[>]{1}$/i],
        'equ':function(value){
            return new Date().moveToLastDayOfMonth();
        }
    },
    {
        //<
        'format':[/^[<]{1}$/i],
        'equ':function(value){
            return new Date().moveToFirstDayOfMonth();
        }
    },
    {
        //+>
        'format':[/^[+]{1}[>]{1}$/i],
        'equ':function(value){
            return Date.today().moveToLastDayOfMonth();
        }
    },
    {
        //->
        'format':[/^[-]{1}[>]{1}$/i],
        'equ':function(value){
            return Date.today().moveToLastDayOfMonth();
        }
    },
    {
        //+1
        'format':[/^[+]{1}[0-9]{1,}$/i],
        'equ':function(value){
            return Date.parse(value);
        }
    },
    {
        //-1
        'format':[/^[-]{1}[0-9]{1,}$/i],
        'equ':function(value){
            return Date.parse(value);
        }
    },
    {
        //+(n)
        'format':[/^[+]{1}[0-9]{1,}$/i],
        'equ':function(value){
            return Date.parse(value);
        }
    },
    {
        //+(n)
        'format':[/^[-]{1}[0-9]{1,}$/i],
        'equ':function(value){
            return Date.parse(value);
        }
    },
    {
        //+(n)
        'format':[/^[+]{2,}$/i],
        'equ':function(value){
            return Date.parse('+'+(value.split("+").length-2).toString());
        }
    },
    {
        //(-n)
        'format':[/^[-]{2,}$/i],
        'equ':function(value){
            return Date.parse('-'+(value.split("-").length-2).toString());
        }
    },
    {
        //12APR
        'format':[/^[0-9]{1,2}[a-zA-Z]{3}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/([0-9]{1,2})([a-zA-Z]{3})/i, '$1'));
            var month = value.replace(/([0-9]{1,2})([a-zA-Z]{3})/i, '$2');
            var monthNum = Date.getMonthNumberFromName(month)
            if(Date.validateMonth(monthNum))
            {
                var formated = Date.today().set({'day':day,'month':monthNum})
                var checkSum = Date.today().compareTo(formated)
                if(checkSum==1)
                    formated.addYears(1)
                return formated
            }
            else
                throw "Not a valid month"

        }
    },
    {
        //12APR12
        //12/APR/12
        'format':[/^[0-9]{1,2}(\/){0,1}[a-zA-Z]{3}(\/){0,1}[0-9]{2,4}$/i],
        'equ':function(value){
            var date = value.replace(/([0-9]{1,2})(\/{0,1})([a-zA-Z]{3})(\/{0,1})([0-9]{2,4})/i, '$1')
            var month = value.replace(/([0-9]{1,2})(\/{0,1})([a-zA-Z]{3})(\/{0,1})([0-9]{2,4})/i, '$3')
            var year = parseInt(value.replace(/([0-9]{1,2})(\/{0,1})([a-zA-Z]{3})(\/{0,1})([0-9]{2,4})/i, '$5'))
            if(year<1000)
                year = year+2000
            return Date.parse(date+"/"+month+"/"+year);
        }
    },
    {
        //+12w
        'format':[/^[+]{1}[0-9]{1,}[w]{1}$/i],
        'equ':function(value){
            var week = parseInt(value.match(/\d+/)[0]);
            return Date.today().addWeeks(week);
        }
    },
    {
        //-12w
        'format':[/^[-]{1}[0-9]{1,}[w]{1}$/i],
        'equ':function(value){
            var week = parseInt(value.match(/\d+/)[0])*-1;
            return Date.today().addWeeks(week);
        }
    },
    {
        //+12d
        'format':[/^[+]{1}[0-9]{1,}[d]{1}$/i],
        'equ':function(value){
            var days = parseInt(value.match(/\d+/)[0])-1;
            return Date.today().addDays(days);
        }
    },
    {
        //-12d
        'format':[/^[-]{1}[0-9]{1,}[d]{1}$/i],
        'equ':function(value){
            var days = (parseInt(value.match(/\d+/)[0])-1)*-1;
            return Date.today().addDays(days);
        }
    },
    {
        //+12m
        'format':[/^[+]{1}[0-9]{1,}[m]{1}$/i],
        'equ':function(value){
            var months = parseInt(value.match(/\d+/)[0]);
            return Date.today().addMonths(months);
        }
    },
    {
        //-12m
        'format':[/^[-]{1}[0-9]{1,}[m]{1}$/i],
        'equ':function(value){
            var months = parseInt(value.match(/\d+/)[0])*-1;
            return Date.today().addMonths(months);
        }
    },
    {
        //+12mon
        'format':[/^[+]{1}[0-9]{1,}(mon|tue|wed|thu|fri|sat|sun|lun|mar|mer|jeu|ven|sam|dim){1}$/i],
        'equ':function(value){
            var numWeeks = value.replace(/([+])([0-9]{1,})([a-zA-Z]{3})/i, '$2');
            var nameDay = value.replace(/([+])([0-9]{1,})([a-zA-Z]{3})/i, '$3');
            var daysIndex = ['dim','lun','mar','mer','jeu','ven','sam']
            var day = Date.getDayNumberFromName(nameDay);
            if(day==-1)
                day = daysIndex.indexOf(nameDay);
            var returnDate = Date.today()
            while (numWeeks>0)
            {
               returnDate = returnDate.moveToDayOfWeek(day,+1);
               numWeeks --;
            }
            return returnDate;
        }
    },
    {
        //-12mon
        'format':[/^[-]{1}[0-9]{1,}(mon|tue|wed|thu|fri|sat|sun|lun|mar|mer|jeu|ven|sam|dim){1}$/i],
        'equ':function(value){
            var numWeeks = value.replace(/([-])([0-9]{1,})([a-zA-Z]{3})/i, '$2');
            var nameDay = value.replace(/([-])([0-9]{1,})([a-zA-Z]{3})/i, '$3');
            var daysIndex = ['dim','lun','mar','mer','jeu','ven','sam']
            var day = Date.getDayNumberFromName(nameDay);
            if(day==-1)
                day = daysIndex.indexOf(nameDay);
            var returnDate = Date.today()
            while (numWeeks>0)
            {
               returnDate = returnDate.moveToDayOfWeek(day,-1);
               numWeeks --;
            }
            return returnDate;
        }
    },
    {
        //+mon
        'format':[/^[+]{1}(mon|tue|wed|thu|fri|sat|sun|lun|mar|mer|jeu|ven|sam|dim){1}$/i],
        'equ':function(value){
            var nameDay = value.replace(/([+]{1})([a-zA-Z]{3})/i, '$2');
            var daysIndex = ['dim','lun','mar','mer','jeu','ven','sam']
            var day = Date.getDayNumberFromName(nameDay);
            if(day==-1)
                day = daysIndex.indexOf(nameDay)
            return Date.today().moveToDayOfWeek(day,+1);
        }
    },
    {
        //-mon
        'format':[/^[-](mon|tue|wed|thu|fri|sat|sun|lun|mar|mer|jeu|ven|sam|dim){1}$/i],
        'equ':function(value){
            var nameDay = value.replace(/([-]{1})([a-zA-Z]{3})/i, '$2')
            var daysIndex = ['dim','lun','mar','mer','jeu','ven','sam']
            var day = Date.getDayNumberFromName(nameDay);
            if(day==-1)
                day = daysIndex.indexOf(nameDay)
            return Date.today().moveToDayOfWeek(day,-1);
        }
    },
    {
        //+12>
        'format':[/^[+]{1}[0-9]{1,2}[>]{1}$/i],
        'equ':function(value){
            var months = parseInt(value.match(/\d+/)[0]);
            return Date.today().addMonths(months).moveToLastDayOfMonth();
        }
    },
    {
        //-12>
        'format':[/^[-]{1}[0-9]{1,2}[>]{1}$/i],
        'equ':function(value){
            var months = parseInt(value.match(/\d+/)[0])*-1;
            return Date.today().addMonths(months).moveToLastDayOfMonth();
        }
    },
];

//common formats for all 3 conversions
var commonFormat = [
    {
        //>APR
        //APR>
        'format':[/^[>]{1}[a-zA-Z]{3}$/i,/^[a-zA-Z]{3}[>]{1}$/i],
        'equ':function(value){
            var month = value.match(/[a-zA-Z]+/)[0];
            var date = new Date();
            var monthNum = Date.getMonthNumberFromName(month)
            if(Date.validateMonth(monthNum))
            {
                date = Date.today().moveToMonth(monthNum);
            }
            else
                throw "Not a valid month"
            return date.moveToLastDayOfMonth()
        }
    },
    {
        //>1
        //>/1
        //>12
        //>/12
        // 1>
        // /1>
        // 12>
        // /12>
        'format':[/^[>]{1}[\/]{0,1}[0-9]{1,2}$/i,/^[0-9]{1,2}[\/]{0,1}[>]{1}$/i],
        'equ':function(value){
            var month = parseInt(value.match(/\d+/)[0])-1;
            var date = new Date();
            if(month>=0 && month<12 && Date.validateMonth(month))
                date = Date.today().moveToMonth(month);
            else
                throw "Not a valid month"
            return date.moveToLastDayOfMonth()
        }
    },
    {
        //>/APR/2012
        //>APR12
        'format':[/[>]{1}(\/){0,1}[a-zA-Z]{3}(\/){0,1}[0-9]{2,4}/i,],
        'equ':function(value){
            var month = value.replace(/([>]{1})(\/{0,1})([a-zA-Z]{3})(\/{0,1})([0-9]{2,4})/i,'$3');
            month = Date.getMonthNumberFromName(month)
            if(!Date.validateMonth(month))
                throw "Not a valid month"
            var year = parseInt(value.replace(/([>]{1})(\/{0,1})([a-zA-Z]{3})(\/{0,1})([0-9]{2,4})/i,'$5'));
            if(year<1000)
                year = 2000+year;
            var date = Date.today().set({'day':1,'month':month,'year':year});
            return date.moveToLastDayOfMonth()
        }
    },
    {
        //1FEB3
        //12FEB3
        'format':[/^[0-9]{1,2}[a-zA-Z]{3}[0-9]{1}$/i],
        'equ':function(value){
            var dateUsable = value.replace(/([0-9]{1,2})([a-zA-Z]{3})([0-9]{1})/i,'$1/$2/');
            var year = parseInt(value.replace(/([0-9]{1,2})([a-zA-Z]{3})([0-9]{1})/i,'$3'));
            year = year+2000;
            return Date.parse(dateUsable+year.toString())
        }
    },
    {
        // 1 (set day)
        'format':[/^[0-9]{1,2}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/([0-9]{1,2})/i,'$1'))
            var date = Date.today().set({'day':day});
            var formated = date;
            var checkSum = Date.today().compareTo(formated)
            if(checkSum==1)
                formated.addYears(1)
            return formated
        }
    }
]

// dd/mm/yyyy format conversions
var ddmmyyyy = [
    {
        //>112
        //>/1/12
        //>1/12
        //>/12/12
        //>1212
        //>/12/2012
        'format':[/^[>]{1}(\/){0,1}[0-9]{1,2}(\/){0,1}[0-9]{2,4}$/i,],
        'equ':function(value){
            var month = parseInt(value.replace(/([>]{1})(\/{0,1})([0-9]{1,2})(\/{0,1})([0-9]{2,4})/i,'$3'))-1;
            var year = parseInt(value.replace(/([>]{1})(\/{0,1})([0-9]{1,2})(\/{0,1})([0-9]{2,4})/i,'$5'));
            if(!Date.validateMonth(month))
                throw "Not a valid month"
            if(year<1000)
                year = 2000+year;
            var date = Date.today().set({'day':1,'month':month,'year':year});
            return date.moveToLastDayOfMonth()
        }
    },
    {
        //12/12
        'format':[/^[0-9]{1,2}[\/]{1}[0-9]{1,2}$/i],
        'equ':function(value){
            var month = parseInt(value.replace(/([0-9]{1,2})(\/{1})([0-9]{1,2})/i,'$3'))-1;
            var day = parseInt(value.replace(/([0-9]{1,2})(\/{1})([0-9]{1,2})/i,'$1'));
            var date = Date.today().set({'day':day,'month':month});
            var formated = date;
            var checkSum = Date.today().compareTo(formated)
            if(checkSum==1)
                formated.addYears(1)
            return formated
        }
    },
    {
        //1212
        'format':[/^[0-9]{2}[0-9]{2}$/i],
        'equ':function(value){
            var month = parseInt(value.replace(/([0-9]{2})([0-9]{2})/i,'$2'))-1;
            var day = parseInt(value.replace(/([0-9]{2})([0-9]{2})/i,'$1'));
            var date = Date.today().set({'day':day,'month':month});
            var formated = date;
            var checkSum = Date.today().compareTo(formated)
            if(checkSum==1)
                formated.addYears(1)
            return formated
        }
    },
    {
        //12/12/12
        'format':[/^[0-9]{1,2}[\/]{1}[0-9]{1,2}[\/]{1}[0-9]{2,4}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/^([0-9]{1,2})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{2,4})$/i,'$1'));
            var month = parseInt(value.replace(/^([0-9]{1,2})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{2,4})$/i,'$3'))-1;
            var year = parseInt(value.replace(/^([0-9]{1,2})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{2,4})$/i,'$5'));
            if(year<1000)
                year = year+2000
            var date = Date.today().set({'day':day,'month':month,'year':year});
            return date
        }
    },
    {
        //12/12/1
        'format':[/^[0-9]{1,2}[\/]{1}[0-9]{1,2}[\/]{1}[0-9]{1}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/^([0-9]{1,2})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{1})$/i,'$1'));
            var month = parseInt(value.replace(/^([0-9]{1,2})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{1})$/i,'$3'))-1;
            var year = 2000+parseInt(value.replace(/^([0-9]{1,2})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{1})$/i,'$5'));
            var date = Date.today().set({'day':day,'month':month,'year':year});
            return date
        }
    },
    {
        //121212
        'format':[/^[0-9]{2}[0-9]{2}[0-9]{2}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{2})/i,'$1'));
            var month = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{2})/i,'$2'))-1;
            var year = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{2})/i,'$3'));
            year = year+2000
            var date = Date.today().set({'day':day,'month':month,'year':year});
            return date
        }
    },
    {
        //121212
        'format':[/^[0-9]{2}[0-9]{2}[0-9]{4}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{4})/i,'$1'));
            var month = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{4})/i,'$2'))-1;
            var year = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{4})/i,'$3'));
            var date = Date.today().set({'day':day,'month':month,'year':year});
            return date
        }
    },
]

// mm/dd/yyyy format conversions
var mmddyyyy = [
    {
        //1>12
        //1/>/12
        //12/>/12
        //12>12
        //12/>/2012
        'format':[/^[0-9]{1,2}(\/){0,1}[>]{1}(\/){0,1}[0-9]{2,4}$/i,],
        'equ':function(value){
            var month = parseInt(value.replace(/([0-9]{1,2})(\/{0,1})([>]{1})(\/{0,1})([0-9]{2,4})/i,'$1'))-1;
            var year = parseInt(value.replace(/([0-9]{1,2})(\/{0,1})([>]{1})(\/{0,1})([0-9]{2,4})/i,'$5'));
            if(!Date.validateMonth(month))
                throw "Not a valid month"
            if(year<1000)
                year = 2000+year;
            var date = Date.today().set({'day':1,'month':month,'year':year});
            return date.moveToLastDayOfMonth()
        }
    },
    {
        //12/12
        'format':[/^[0-9]{1,2}[\/]{1}[0-9]{1,2}$/i],
        'equ':function(value){
            var month = parseInt(value.replace(/([0-9]{1,2})(\/{1})([0-9]{1,2})/i,'$1'))-1;
            var day = parseInt(value.replace(/([0-9]{1,2})(\/{1})([0-9]{1,2})/i,'$3'));
            var date = Date.today().set({'day':day,'month':month});
            var formated = date;
            var checkSum = Date.today().compareTo(formated)
            if(checkSum==1)
                formated.addYears(1)
            return formated
        }
    },
    {
        //1212
        'format':[/^[0-9]{2}[0-9]{2}$/i],
        'equ':function(value){
            var month = parseInt(value.replace(/([0-9]{2})([0-9]{2})/i,'$1'))-1;
            var day = parseInt(value.replace(/([0-9]{2})([0-9]{2})/i,'$2'));
            var date = Date.today().set({'day':day,'month':month});
            var formated = date;
            var checkSum = Date.today().compareTo(formated)
            if(checkSum==1)
                formated.addYears(1)
            return formated
        }
    },
    {
        //12/12/12
        'format':[/^[0-9]{1,2}[\/]{1}[0-9]{1,2}[\/]{1}[0-9]{1,4}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/^([0-9]{1,2})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{1,4})$/i,'$3'));
            var month = parseInt(value.replace(/^([0-9]{1,2})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{1,4})$/i,'$1'))-1;
            var year = parseInt(value.replace(/^([0-9]{1,2})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{1,4})$/i,'$5'));
            if(year<1000)
                year = year+2000
            var date = Date.today().set({'day':day,'month':month,'year':year});
            return date
        }
    },
    {
        //121212
        'format':[/^[0-9]{2}[0-9]{2}[0-9]{2,4}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{2,4})/i,'$2'));
            var month = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{2,4})/i,'$1'))-1;
            var year = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{2,4})/i,'$3'));
            if(year<1000)
                year = year+2000
            var date = Date.today().set({'day':day,'month':month,'year':year});
            return date
        }
    },
]

// yyyy/mm/dd format conversions
var yyyymmdd = [
    {
        //1212>
        'format':[/^[0-9]{2}[0-9]{2}[>]{1}$/i],
        'equ':function(value){
            var year = 2000+parseInt(value.replace(/([0-9]{2})([0-9]{2})(>{1})/i,'$1'));
            var month = parseInt(value.replace(/([0-9]{2})([0-9]{2})(>{1})/i,'$2'))-1;
            var date = Date.today().set({'year':year,'month':month});
            return date.moveToLastDayOfMonth();
        }
    },
    {
        //112>
        //1/12/>
        //12/12/>
        //1212>
        //2012/12/>
        'format':[/^[0-9]{2,4}(\/){0,1}[0-9]{1,2}(\/){0,1}[>]{1}$/i],
        'equ':function(value){
            var month = parseInt(value.replace(/([0-9]{2,4})(\/{0,1})([0-9]{1,2})(\/{0,1})([>]{1})/i,'$3'))-1;
            var year = parseInt(value.replace(/([0-9]{2,4})(\/{0,1})([0-9]{1,2})(\/{0,1})([>]{1})/i,'$1'));
            if(!Date.validateMonth(month))
                throw "Not a valid month"
            if(year<1000)
                year = 2000+year;
            var date = Date.today().set({'day':1,'month':month,'year':year});
            return date.moveToLastDayOfMonth();
        }
    },
    {
        //12/12
        'format':[/^[0-9]{1,2}[\/]{1}[0-9]{1,2}$/i],
        'equ':function(value){
            var month = parseInt(value.replace(/([0-9]{1,2})(\/{1})([0-9]{1,2})/i,'$1'))-1;
            var day = parseInt(value.replace(/([0-9]{1,2})(\/{1})([0-9]{1,2})/i,'$3'));
            var date = Date.today().set({'day':day,'month':month});
            var formated = date;
            var checkSum = Date.today().compareTo(formated)
            if(checkSum==1)
                formated.addYears(1)
            return formated;
        }
    },
    {
        //1212
        'format':[/^[0-9]{2}[0-9]{2}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/([0-9]{2})([0-9]{2})/i,'$2'));
            var month = parseInt(value.replace(/([0-9]{2})([0-9]{2})/i,'$1'))-1;
            var date = Date.today().set({'day':day,'month':month});
            var formated = date;
            var checkSum = Date.today().compareTo(formated)
            if(checkSum==1)
                formated.addYears(1)
            return formated;
        }
    },
    {
        //121212
        'format':[/^[0-9]{2}[0-9]{2}[0-9]{2}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{2})/i,'$3'));
            var month = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{2})/i,'$2'))-1;
            var year = parseInt(value.replace(/([0-9]{2})([0-9]{2})([0-9]{2})/i,'$1'));
            year = year+2000
            var date = Date.today().set({'day':day,'month':month,'year':year});
            return date;
        }
    },
    {
        // 20121212
        'format':[/^[0-9]{4}[0-9]{2}[0-9]{2}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/([0-9]{4})([0-9]{2})([0-9]{2})/i,'$3'));
            var month = parseInt(value.replace(/([0-9]{4})([0-9]{2})([0-9]{2})/i,'$2'))-1;
            var year = parseInt(value.replace(/([0-9]{4})([0-9]{2})([0-9]{2})/i,'$1'));
            var date = Date.today().set({'day':day,'month':month,'year':year});
            return date;
        }
    },
    {
        //12/12/12
        'format':[/^[0-9]{1,4}[\/]{1}[0-9]{1,2}[\/]{1}[0-9]{1,2}$/i],
        'equ':function(value){
            var day = parseInt(value.replace(/^([0-9]{1,4})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{1,2})$/i,'$5'));
            var month = parseInt(value.replace(/^([0-9]{1,4})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{1,2})$/i,'$3'))-1;
            var year = parseInt(value.replace(/^([0-9]{1,4})([\/]{1})([0-9]{1,2})([\/]{1})([0-9]{1,2})$/i,'$1'));
            if(year<1000)
                year = year+2000
            var date = Date.today().set({'day':day,'month':month,'year':year});
            return date;
        }
    }
]

var lFormat=[
    {
        //=
        'format':[/^[l]{1}[=]{1}$/i],
        'equ':function(value){
            return Date.parse('t');
        }
    },
    {
        //>
        'format':[/^[l]{1}>{1}$/i],
        'equ':function(value){
            return new Date().moveToLastDayOfMonth();
        }
    },
    {
        //<
        'format':[/^[l]{1}<{1}$/i],
        'equ':function(value){
            return new Date().moveToFirstDayOfMonth();
        }
    },
    {
        //+>
        'format':[/^[l]{1}[+]{1}[>]{1}$/i],
        'equ':function(value){
            return Date.today().moveToLastDayOfMonth();
        }
    },
    {
        //->
        'format':[/^[l]{1}[-]{1}[>]{1}$/i],
        'equ':function(value){
            return Date.today().moveToLastDayOfMonth();
        }
    },
    {
        //+1
        'format':[/^[l]{1}[+]{1}[0-9]{1,}$/i],
        'equ':function(value){
            return Date.parse(value);
        }
    },
    {
        //-1
        'format':[/^[l]{1}[-]{1}[0-9]{1,}$/i],
        'equ':function(value){
            return Date.parse(value);
        }
    },
    {
        //+(n)
        'format':[/^[l]{1}[+]{1}[0-9]{1,}$/i],
        'equ':function(value){
            return Date.parse(value);
        }
    },
    {
        //+(n)
        'format':[/^[l]{1}[-]{1}[0-9]{1,}$/i],
        'equ':function(value){
            return Date.parse(value);
        }
    },
    {
        //+(n)
        'format':[/^[l]{1}[+]{2,}$/i],
        'equ':function(value){
            return Date.parse('+'+(value.split("+").length-2).toString());
        }
    },
    {
        //(-n)
        'format':[/^[l]{1}[-]{2,}$/i],
        'equ':function(value){
            return Date.parse('-'+(value.split("-").length-2).toString());
        }
    },
    {
        //+12w
        'format':[/^[l]{1}[+]{1}[0-9]{1,}[w]{1}$/i],
        'equ':function(value){
            var week = parseInt(value.match(/\d+/)[0]);
            return Date.today().addWeeks(week);
        }
    },
    {
        //-12w
        'format':[/^[l]{1}[-]{1}[0-9]{1,}[w]{1}$/i],
        'equ':function(value){
            var week = parseInt(value.match(/\d+/)[0])*-1;
            return Date.today().addWeeks(week);
        }
    },
    {
        //+12d
        'format':[/^[l]{1}[+]{1}[0-9]{1,}[d]{1}$/i],
        'equ':function(value){
            var days = parseInt(value.match(/\d+/)[0])-1;
            return Date.today().addDays(days);
        }
    },
    {
        //-12d
        'format':[/^[l]{1}[-]{1}[0-9]{1,}[d]{1}$/i],
        'equ':function(value){
            var days = (parseInt(value.match(/\d+/)[0])-1)*-1;
            return Date.today().addDays(days);
        }
    },
    {
        //+12m
        'format':[/^[l]{1}[+]{1}[0-9]{1,}[m]{1}$/i],
        'equ':function(value){
            var months = parseInt(value.match(/\d+/)[0]);
            return Date.today().addMonths(months);
        }
    },
    {
        //-12m
        'format':[/^[l]{1}[-]{1}[0-9]{1,}[m]{1}$/i],
        'equ':function(value){
            var months = parseInt(value.match(/\d+/)[0])*-1;
            return Date.today().addMonths(months);
        }
    },
    {
        //+12mon
        'format':[/^[l]{1}[+]{1}[0-9]{1,}(mon|tue|wed|thu|fri|sat|sun|lun|mar|mer|jeu|ven|sam|dim){1}$/i],
        'equ':function(value){
            var numWeeks = value.replace(/[l]{1}([+])([0-9]{1,})([a-zA-Z]{3})/i, '$3');
            var nameDay = value.replace(/[l]{1}([+])([0-9]{1,})([a-zA-Z]{3})/i, '$4');
            var daysIndex = ['dim','lun','mar','mer','jeu','ven','sam']
            var day = Date.getDayNumberFromName(nameDay);
            if(day==-1)
                day = daysIndex.indexOf(nameDay);
            var returnDate = Date.today()
            while (numWeeks>0)
            {
               returnDate = returnDate.moveToDayOfWeek(day,+1);
               numWeeks --;
            }
            return returnDate;
        }
    },
    {
        //-12mon
        'format':[/^[l]{1}[-]{1}[0-9]{1,}(mon|tue|wed|thu|fri|sat|sun|lun|mar|mer|jeu|ven|sam|dim){1}$/i],
        'equ':function(value){
            var numWeeks = value.replace(/[l]{1}([-])([0-9]{1,})([a-zA-Z]{3})/i, '$3');
            var nameDay = value.replace(/[l]{1}([-])([0-9]{1,})([a-zA-Z]{3})/i, '$4');
            var daysIndex = ['dim','lun','mar','mer','jeu','ven','sam']
            var day = Date.getDayNumberFromName(nameDay);
            if(day==-1)
                day = daysIndex.indexOf(nameDay);
            var returnDate = Date.today()
            while (numWeeks>0)
            {
               returnDate = returnDate.moveToDayOfWeek(day,-1);
               numWeeks --;
            }
            return returnDate;
        }
    },
    {
        //+mon
        'format':[/^[l]{1}[+]{1}(mon|tue|wed|thu|fri|sat|sun|lun|mar|mer|jeu|ven|sam|dim){1}$/i],
        'equ':function(value){
            var nameDay = value.replace(/[l]{1}([+]{1})([a-zA-Z]{3})/i, '$3');
            var daysIndex = ['dim','lun','mar','mer','jeu','ven','sam']
            var day = Date.getDayNumberFromName(nameDay);
            if(day==-1)
                day = daysIndex.indexOf(nameDay)
            return Date.today().moveToDayOfWeek(day,+1);
        }
    },
    {
        //-mon
        'format':[/^[l]{1}[-](mon|tue|wed|thu|fri|sat|sun|lun|mar|mer|jeu|ven|sam|dim){1}$/i],
        'equ':function(value){
            var nameDay = value.replace(/[l]{1}([-]{1})([a-zA-Z]{3})/i, '$3')
            var daysIndex = ['dim','lun','mar','mer','jeu','ven','sam']
            var day = Date.getDayNumberFromName(nameDay);
            if(day==-1)
                day = daysIndex.indexOf(nameDay)
            return Date.today().moveToDayOfWeek(day,-1);
        }
    },
    {
        //+12>
        'format':[/^[l]{1}[+]{1}[0-9]{1,2}[>]{1}$/i],
        'equ':function(value){
            var months = parseInt(value.match(/\d+/)[0]);
            return Date.today().addMonths(months).moveToLastDayOfMonth();
        }
    },
    {
        //-12>
        'format':[/^[l]{1}[-]{1}[0-9]{1,2}[>]{1}$/i],
        'equ':function(value){
            var months = parseInt(value.match(/\d+/)[0])*-1;
            return Date.today().addMonths(months).moveToLastDayOfMonth();
        }
    },
]

//this variable will contain total formats
var changeFormats = [];

var formatDefined = {'dd/mm/yyyy':ddmmyyyy,'mm/dd/yyyy':mmddyyyy,'yyyy/mm/dd':yyyymmdd};

//concatinative command and special character formats
changeFormats = changeFormats.concat(normalFormat);
changeFormats = changeFormats.concat(commonFormat);
changeFormats = changeFormats.concat(lFormat);

//will return total valid formats for that particular date format
function getDefinedFormat(format){
    if(formatDefined[format]){
        return changeFormats.concat(formatDefined[format]);
    };

    return changeFormats;
}


module.exports = {
    getDateFormat,
    getDefinedFormat,
    formatDefined,
};